import React, { useEffect } from "react";
import {CKEditor} from "@ckeditor/ckeditor5-react";
//import ClassicEditor from "ckeditor-c-build/ckeditor";
import ClassicEditor from "ckeditor-hashure-build/ckeditor";

const CkEditor = (props) => {
   const {form, field} = props;
   
   return (
      <div className="col-span-2">
         <label className="leading-2">{props.label}</label>
         <CKEditor
            editor={ClassicEditor}
            data={props.field.value}
            onChange={(event, editor) => {
               const data = editor.getData();
               form.setFieldValue(field.name, data);
            }}
           
         />
      </div>
   );
};

export default CkEditor;